<template>
  <div class="ficha-mapa ficha-avistamiento-fauna-aves">
    <div class="encabezado">Avistamiento de fauna | Aves</div>
    <div class="contenedor">
      <Carousel
        class="oculto-escritorio"
        :altura="300"
        :id="'carrusel-avistamiento'"
        :lista="lista_fotos"
      />
      <div class="col">
        <div class="ficha">
          <div class="ficha-foto oculto-movil">
            <img
              class="foto"
              src="descargables/galeria-aves/1_Buho-Sabanero.jpg"
              alt=""
            />
            <div class="degradado-aves"></div>
            <div class="cuadro-contraste-aves"></div>
            <p class="pie-foto">Búho Sabanero <i>Assio Flammeus</i></p>
          </div>
          <div class="ficha-cuerpo">
            <ul class="m-t-0-md">
              <li>
                En esta área se congregan de manera regular más del 1% de la
                población de especies de aves marinas y terrestres del mundo.
              </li>
              <li>
                Se estima que el Lago de Texcoco da refugio a más de 200,000
                aves acuáticas.
              </li>
              <li>
                El Lago de Texcoco es sitio de invernada, descanso y
                alimentación para numerosas aves migratorias provenientes de
                Canadá, Estados Unidos y el Norte de México.
              </li>
              <li>
                De las 263 especies registradas en esta área, 17 están en riesgo
                de acuerdo con la NOM-59-SEMARNAT-2010 y se presentan en estas
                fotografías.
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="contenedor-galeria">
        <GaleriaAves
          class="oculto-movil"
          cover="descargables/galeria-aves/2_Pato-de-Collar.jpg "
          name="Pato de Collar"
          namec="Anas platyrhynchos diazi"
        />

        <GaleriaAves
          class="oculto-movil"
          cover="descargables/galeria-aves/3_Rascon-Cara-Gris.jpg"
          name="Rascón Cara Gris"
          namec="Rallus limicola"
        />
        <GaleriaAves
          class="oculto-movil"
          cover="descargables/galeria-aves/4_Chorlo-Nevado.jpg "
          name="Chorlo Nevado"
          namec="Charadrius nivosus"
        />

        <GaleriaAves
          class="oculto-movil"
          cover="descargables/galeria-aves/5_Avetoro-Norteno.jpg"
          name="Avetoro Norteño"
          namec="Otaurus lentiginosus"
        />
        <GaleriaAves
          class="oculto-movil"
          cover="descargables/galeria-aves/6_Avetoro-Menor.jpg"
          name="Avetoro Menor"
          namec="Ixobrychus exilis"
        />

        <GaleriaAves
          class="oculto-movil"
          cover="descargables/galeria-aves/7_Gavilan-Pecho-Canela.jpg"
          name="Gavilán Pecho"
          namec="Canela Accipiter striatus"
        />
        <GaleriaAves
          class="oculto-movil"
          cover="descargables/galeria-aves/8_Gavilan-Cooper.jpg"
          name="Gavilán de Cooper"
          namec="Accipiter cooperii"
        />

        <GaleriaAves
          class="oculto-movil"
          cover="descargables/galeria-aves/9_Aguililla-Rojinegra.jpg"
          name="Aguililla Rojinegra"
          namec="Parabuteo unicinctus"
        />
        <GaleriaAves
          class="oculto-movil"
          cover="descargables/galeria-aves/10_Aguililla-Cola-Blanca.jpg"
          name="Aguililla Cola Blanca"
          namec="Geranoaetus Albicaudatus"
        />

        <GaleriaAves
          class="oculto-movil"
          cover="descargables/galeria-aves/11_Aguililla-Pecho-Rojo.jpg"
          name="Aguililla Pecho Rojo"
          namec="Buteo lineatus"
        />
        <GaleriaAves
          class="oculto-movil"
          cover="descargables/galeria-aves/12_Agulilla-swainsoni.jpg"
          name="Aguililla de Swainson "
          namec="Buteo swainsoni"
        />

        <GaleriaAves
          class="oculto-movil"
          cover="descargables/galeria-aves/13_Aguililla-Aura.jpg"
          name="Aguililla Aura "
          namec="Buteo albonotatus"
        />
        <GaleriaAves
          class="oculto-movil"
          cover="descargables/galeria-aves/14_Aguililla-Alas-Anchas.jpg"
          name="Aguililla Alas Anchas "
          namec="Buteo platypterus"
        />

        <GaleriaAves
          class="oculto-movil"
          cover="descargables/galeria-aves/15_Aguililla-Real.jpg"
          name="Aguililla Real "
          namec="Buteo regalis"
        />
        <GaleriaAves
          class="oculto-movil"
          cover="descargables/galeria-aves/16-Halcon-Peregrino.jpg"
          name="Halcón peregrino "
          namec="Falco peregrinus"
        />

        <GaleriaAves
          class="oculto-movil"
          cover="descargables/galeria-aves/17_Chipe-Lores-Negro.jpg"
          name="Chipe Lores Negros "
          namec="Geothlypis tolmiei"
        />
      </div>
    </div>
  </div>
</template>

<script>
import GaleriaAves from "@/components/mapa-diagnostico/fichas/GaleriaAves.vue";
import Carousel from "@/components/base/Carousel.vue";

export default {
  name: "AvistamientoDeFaunaAves",
  components: {
    GaleriaAves,
    Carousel,
  },
  data() {
    return {
      lista_fotos: [
        [
          "descargables/galeria-aves/1_Buho-Sabanero.jpg",
          "Búho Sabanero <br/><i>Assio Flammeus</i>",
        ],
        [
          "descargables/galeria-aves/2_Pato-de-Collar.jpg ",
          "Pato de Collar <br/><i>Anas platyrhynchos diazi</i>",
        ],
        [
          "descargables/galeria-aves/3_Rascon-Cara-Gris.jpg",
          "Rascón Cara Gris <br/><i>Rallus limicola</i>",
        ],
        [
          "descargables/galeria-aves/4_Chorlo-Nevado.jpg ",
          "Chorlo Nevado <br/><i>Charadrius nivosus</i>",
        ],
        [
          "descargables/galeria-aves/5_Avetoro-Norteno.jpg",
          "Avetoro Norteño <br/><i>Otaurus lentiginosus</i>",
        ],
        [
          "descargables/galeria-aves/6_Avetoro-Menor.jpg",
          "Avetoro Menor <br/><i>Ixobrychus exilis</i>",
        ],
        [
          "descargables/galeria-aves/7_Gavilan-Pecho-Canela.jpg",
          "Gavilán Pecho <br/><i>Canela Accipiter striatus</i>",
        ],
        [
          "descargables/galeria-aves/8_Gavilan-Cooper.jpg",
          "Gavilán de Cooper <br/><i>Accipiter cooperii</i>",
        ],
        [
          "descargables/galeria-aves/9_Aguililla-Rojinegra.jpg",
          "Aguililla Rojinegra <br/><i>Parabuteo unicinctus</i>",
        ],
        [
          "descargables/galeria-aves/10_Aguililla-Cola-Blanca.jpg",
          "Aguililla Cola Blanca <br/><i>Geranoaetus Albicaudatus</i>",
        ],
        [
          "descargables/galeria-aves/11_Aguililla-Pecho-Rojo.jpg",
          "Aguililla Pecho Rojo <br/><i>Buteo lineatus</i>",
        ],
        [
          "descargables/galeria-aves/12_Agulilla-swainsoni.jpg",
          "Aguililla de Swainson  <br/><i>Buteo swainsoni</i>",
        ],
        [
          "descargables/galeria-aves/13_Aguililla-Aura.jpg",
          "Aguililla Aura  <br/><i>Buteo albonotatus</i>",
        ],
        [
          "descargables/galeria-aves/14_Aguililla-Alas-Anchas.jpg",
          "Aguililla Alas Anchas  <br/><i>Buteo platypterus</i>",
        ],
        [
          "descargables/galeria-aves/15_Aguililla-Real.jpg",
          "Aguililla Real  <br/><i>Buteo regalis</i>",
        ],
        [
          "descargables/galeria-aves/16-Halcon-Peregrino.jpg",
          "Halcón peregrino  <br/><i>Falco peregrinus</i>",
        ],
        [
          "descargables/galeria-aves/17_Chipe-Lores-Negro.jpg",
          "Chipe Lores Negros  <br/><i>Geothlypis tolmiei</i>",
        ],
      ],
    };
  },
};
</script>

<style scoped lang="scss">
$ficha-separador: 20px;

.ficha-avistamiento-fauna-aves {
  .contenedor-galeria {
    .ficha-foto {
      margin: $gap * 0.5;
    }
    @media (min-width: map-get($media-queries-limit, "tablet")) {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: $ficha-separador * 0.5;
      .ficha-foto {
        margin: 0;
      }
    }
  }
}
@media (min-width: map-get($media-queries-limit, "mobile")) {
  div.oculto-escritorio {
    display: none;
  }
  div.oculto-movil {
    display: grid;
  }
}
@media (max-width: map-get($media-queries-limit, "mobile")) {
  div.oculto-escritorio {
    display: inherit;
  }
  div.oculto-movil {
    display: none;
  }
}
.carrusel-cuerpo {
  padding: 0 30px;
}
</style>
